import { useNavigation } from "@react-navigation/native";
import ListItem from "components/atoms/ListItem";
import HStack from "components/atoms/stack/HStack";
import VStack from "components/atoms/stack/VStack";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedLayout, { createRefreshControl } from "components/atoms/ThemedLayout";
import ThemedList from "components/atoms/ThemedList";
import ThemedLoader from 'components/atoms/ThemedLoader';
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import TimeslotIcon from "components/molecules/TimeslotIcon";
import FooterBar from 'components/organisms/FooterBar';
import _ from "lodash";
import { AppRoutes } from "navigations/app-routes";
import { useMemo, useRef } from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import Button from "theme/Button";
import FetchCreditAmounts from "utils/fetch/FetchCreditAmounts";
import FetchTransactions from "utils/fetch/FetchCreditTransactions";
import useFetch from "utils/hooks/useFetch";
import i18n from "utils/i18n";
import Translate from "utils/translate";
import Text from 'theme/Text';
import HelperDate, { dateFormat } from "utils/helper-date";
import HelperPrice from "utils/helper/HelperPrice";

const HomeMoreCreditsTransactionsScene = () => {
	
	const navigation = useNavigation();
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

	const { data, loading } = useFetch( FetchTransactions.fetchAll );

	const layoutRef = useRef( undefined )

	const onPressView = ( item ) => {
		navigation.navigate( AppRoutes.MORE_CREDITS_BUY_PAYMENT, {
			transaction: item?.guid,
		});
	}

	const renderItem = ({ item, index }) => {

		const timeslotKind = _.find( _timeslotKinds, { guid: item?.credit_bundle?.timeslot_kind?.guid } )
		const timeslotKindTitle = Translate.field( timeslotKind, 'title' )

		return (
			<ListItem
				title={ '[#'+ item.id +'] ' + i18n.t( 'page.credits.item.name', { amount: item.amount, timeslotKind: timeslotKindTitle } ) }
				accessoryLeft={(
					<View
						style={ styles.iconContainer }>

						<TimeslotIcon
							style={ styles.iconInner }
							timeslot={{
								kind: timeslotKind?.kind,
								sub_kind: timeslotKind?.sub_kind,
							}}
						/>
					</View>
				)}
				accessoryRight={(
					<HStack>
						<Button 
							onPress={ onPressView.bind( this, item ) }>
							
							{ i18n.t( 'buttons.view' ) }
						</Button>
					</HStack>
				)}>

				<VStack>
					<Text appearance={'hint'}>{ i18n.t('management:generic.created_at') }: { HelperDate.date( item.created_at ).format( dateFormat.DATE_TIME ) }</Text>
					<Text appearance={'hint'}>{ i18n.t('page.credits.transaction.amount') }: { item.amount }</Text>
					<Text appearance={'hint'}>{ i18n.t('page.credits.transaction.credits_amount') }: { item.credits_amount }</Text>
					<Text appearance={'hint'}>{ i18n.t('page.credits.transaction.price') }: { HelperPrice.format( item.price ) }</Text>
					<Text appearance={'hint'}>{ i18n.t('page.credits.transaction.price_total') }: { HelperPrice.format( item.price_total ) }</Text>
					<Text appearance={'hint'}>{ i18n.t('page.credits.transaction.status') }: { i18n.t('page.credits.transaction.status_item.'+ item.status ) }</Text>
				</VStack>
			</ListItem>
		)
	}

	return (
		<ThemedSafeAreaComponentTop 
			top={false}>
			
			<ThemedLayout
				ref={ layoutRef }
				topNavigation={ true }
				showBackButton
				enableFooterBar={ true }
				title={ i18n.t( 'titles.credits' ) }
				scrollViewProps={{
					...createRefreshControl({
						// onRefresh: reloadMessages.bind( this )
					})
				}}>

				{ loading && (
					<ThemedLoader text={ i18n.t( 'basic.loading' ) } />
				)}
				
				<ThemedBlock shadow>
					<ThemedList
						data={ data }
						renderItem={ renderItem.bind( this ) }
						scrollEnabled={ false }
					/>
				</ThemedBlock>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	iconContainer: {
		width: 40,
		height: 40,
	},
	iconInner: {
		transform: [ {
			scale: 0.6
		} ],
	}
})

export default HomeMoreCreditsTransactionsScene;
